// LE PROTOCOL — Accurate Workout Program Data from Original HTML
// GILLES × THE MONSTER PROTOCOL — DIAMOND EDITION

export const PHASE_INFO = {
  1: { id: 1, name: "Foundation", weeks: 12, focus: "Build foundation + correct imbalances", color: "#3B82F6", desc: "Weeks 1-12" },
  2: { id: 2, name: "Mass Build", weeks: 12, focus: "Strength pyramids + hypertrophy volume", color: "#8B5CF6", desc: "Weeks 13-24" },
  3: { id: 3, name: "Power & Sculpt", weeks: 12, focus: "Explosive power + definition", color: "#DC2626", desc: "Weeks 25-36" },
  4: { id: 4, name: "Peak Shred", weeks: 12, focus: "Peak strength + metabolic conditioning", color: "#F59E0B", desc: "Weeks 37-48" },
};

export const WORKOUTS = {
  1: {
    1: {
      name: "Push + Correctives",
      focus: "Push + Correctives",
      warmup: "10min dynamic stretch + 5min hip corrective circuit",
      cardio: "HIIT: 20 min basketball sprint intervals — 30s sprint / 30s walk x 20 rounds",
      exercises: [
        { name: "Barbell Bench Press", sets: 4, reps: "8-10", rest: 90, muscle: "Chest / Front Delt / Triceps", note: "Control eccentric — 3 sec down, explosive up" },
        { name: "Dumbbell Shoulder Press", sets: 3, reps: "10-12", rest: 75, muscle: "All 3 Delt Heads", note: "Neutral grip, don't flare elbows" },
        { name: "Cable Lateral Raises", sets: 4, reps: "15-20", rest: 60, muscle: "Medial Delt", note: "KEY for Duren shoulders — lead with elbow, 3s eccentric", isKey: true },
        { name: "Incline Dumbbell Press", sets: 3, reps: "10-12", rest: 75, muscle: "Upper Chest", note: "30 degree incline, deep stretch, squeeze at top" },
        { name: "Tricep Rope Pushdowns", sets: 3, reps: "12-15", rest: 60, muscle: "Triceps", note: "Flare wrists at bottom for peak contraction" },
        { name: "Side-Lying Clam Shells", sets: 3, reps: "20 each", rest: 30, muscle: "Glute Medius", note: "Band resistance — BOTH sides, glute med activation", isHip: true },
        { name: "QL Stretch — Right Side", sets: 3, reps: "45s hold", rest: 0, muscle: "Quadratus Lumborum", note: "Release overactive right QL pulling hip up", isHip: true },
      ],
    },
    2: {
      name: "Pull + Hip Correctives",
      focus: "Pull + Hip Correctives",
      warmup: "10min dynamic stretch + 5min glute activation",
      cardio: "LISS: 25 min moderate bike or row — Zone 2 conversational pace",
      exercises: [
        { name: "Weighted Pull-Ups", sets: 4, reps: "6-8", rest: 120, muscle: "Lats / Biceps / Rear Delt", note: "Full dead hang to chin over bar — V-taper builder", isKey: true },
        { name: "Barbell Bent-Over Row", sets: 4, reps: "8-10", rest: 90, muscle: "Upper/Mid Back", note: "Squeeze scapula at top — back THICKNESS", isKey: true },
        { name: "Cable Face Pulls", sets: 4, reps: "15", rest: 60, muscle: "Rear Delt / Rotator Cuff", note: "Rope at eye level — rear delt + rotator cuff health" },
        { name: "Single-Arm Dumbbell Row", sets: 3, reps: "10 each", rest: 75, muscle: "Lats / Core", note: "Keep hips SQUARE — anti-rotation for hip balance", isHip: true },
        { name: "EZ-Bar Curl", sets: 3, reps: "10-12", rest: 60, muscle: "Biceps", note: "Slow eccentric (3 sec down) — no swinging" },
        { name: "Lateral Band Walks", sets: 3, reps: "20 each way", rest: 30, muscle: "Glute Medius", note: "Mini band above knees — glute med activation", isHip: true },
        { name: "Single-Leg Glute Bridge", sets: 3, reps: "15 each", rest: 30, muscle: "Glutes / Hip Stability", note: "Start LEFT (weaker) — drive hip LEVEL", isHip: true },
      ],
    },
    3: {
      name: "Legs + Core",
      focus: "Legs + Core",
      warmup: "10min mobility + glute activation protocol",
      exercises: [
        { name: "Barbell Back Squat", sets: 4, reps: "8", rest: 120, muscle: "Quads / Glutes / Core", note: "Below parallel, drive through heels — foundation builder", isKey: true },
        { name: "Bulgarian Split Squat", sets: 3, reps: "10 each", rest: 90, muscle: "Quads / Glutes / Balance", note: "ALWAYS start LEFT leg — extra set weak side", isKey: true, isHip: true },
        { name: "Romanian Deadlift", sets: 3, reps: "10-12", rest: 90, muscle: "Hamstrings / Glutes", note: "Hinge at hips — deep hamstring stretch" },
        { name: "Single-Leg Leg Press", sets: 3, reps: "12 each", rest: 75, muscle: "Quads / Glutes", note: "Same weight both sides — track imbalance", isHip: true },
        { name: "Cable Hip Abduction", sets: 3, reps: "15 each", rest: 45, muscle: "Glute Medius", note: "Low cable, target glute medius — control return", isHip: true },
        { name: "Plank Variations", sets: 3, reps: "45s each", rest: 30, muscle: "Core / Obliques", note: "Front > Side L > Side R rotation" },
        { name: "Hanging Leg Raises", sets: 3, reps: "15", rest: 60, muscle: "Lower Abs", note: "Control the swing — tuck knees to chest" },
      ],
    },
    4: {
      name: "Active Recovery + Cardio",
      focus: "Active Recovery + Cardio",
      exercises: [
        { name: "Basketball Skill Work", sets: 1, reps: "45 min", rest: 0, muscle: "Sport-Specific", note: "Ball handling, free throws, footwork — stay athletic" },
        { name: "Yoga / Mobility Flow", sets: 1, reps: "20 min", rest: 0, muscle: "Flexibility / Recovery", note: "Hip flexors, thoracic spine, QL focus" },
        { name: "Walk (Zone 1)", sets: 1, reps: "20 min", rest: 0, muscle: "Active Recovery", note: "Moderate pace — promotes blood flow + recovery" },
        { name: "Foam Roll Protocol", sets: 1, reps: "10 min", rest: 0, muscle: "Myofascial Release", note: "IT band, QL, hip flexors, thoracic spine" },
      ],
    },
    5: {
      name: "Upper Body Volume",
      focus: "Upper Body Volume",
      warmup: "10min rotator cuff + shoulder mobility",
      cardio: "HIIT: 20 min jump rope intervals — 40s all-out / 20s rest x 20 rounds",
      exercises: [
        { name: "Seated Cable Row (Wide)", sets: 4, reps: "10-12", rest: 75, muscle: "Upper Back / Rear Delts", note: "Wide grip hits upper back and rear delts hard" },
        { name: "Dumbbell Flyes (Flat)", sets: 3, reps: "12-15", rest: 60, muscle: "Chest / Pec Definition", note: "Wide arc — stretch the chest fully" },
        { name: "Barbell Upright Row", sets: 4, reps: "10-12", rest: 75, muscle: "Traps / Delts", note: "TRAP BUILDER — wide grip, pull to chin level", isKey: true },
        { name: "Arnold Press", sets: 3, reps: "12", rest: 75, muscle: "All Delt Heads", note: "Full rotation — hits all 3 delt heads, 3D shoulders" },
        { name: "Dumbbell Shrugs", sets: 4, reps: "15-20", rest: 60, muscle: "Upper Traps", note: "TRAP builder — hold 2 sec squeeze at top", isKey: true },
        { name: "Hammer Curls", sets: 3, reps: "12", rest: 60, muscle: "Brachialis / Forearms", note: "Brachialis = thicker arms from the front" },
        { name: "Overhead Tricep Extension", sets: 3, reps: "12-15", rest: 60, muscle: "Triceps Long Head", note: "Cable or DB — long head for horseshoe shape" },
      ],
    },
    6: {
      name: "Full Body Athletic",
      focus: "Full Body Athletic",
      warmup: "10min dynamic warm-up + hip circuit",
      cardio: "Full court basketball — 30+ min scrimmage or pickup",
      exercises: [
        { name: "Trap Bar Deadlift", sets: 4, reps: "6", rest: 120, muscle: "Full Posterior Chain", note: "Full body power — push the floor away", isKey: true },
        { name: "Dumbbell Walking Lunges", sets: 3, reps: "12 each", rest: 75, muscle: "Quads / Glutes / Balance", note: "Long steps — hip stability + quad builder" },
        { name: "Push-Ups (3 variations)", sets: 3, reps: "15 each", rest: 45, muscle: "Chest / Triceps", note: "Wide > Diamond > Decline rotation" },
        { name: "Single-Leg Romanian DL", sets: 3, reps: "10 each", rest: 60, muscle: "Hamstrings / Glute Med", note: "KEY hip correction — standing leg glute fires hard", isKey: true, isHip: true },
        { name: "Box Jumps", sets: 4, reps: "5", rest: 90, muscle: "Explosive Power", note: "Explosive — soft landing, step down (save knees)" },
        { name: "Copenhagen Adductor Plank", sets: 3, reps: "20s each", rest: 30, muscle: "Adductors / Core", note: "Hip adductor balance — squeeze HARD", isHip: true },
        { name: "Battle Ropes", sets: 5, reps: "30s", rest: 30, muscle: "Full Body Conditioning", note: "Full body conditioning finisher — all out" },
      ],
    },
  },
  2: {
    1: {
      name: "Push Strength Pyramid",
      focus: "Push Strength Pyramid",
      warmup: "10min dynamic + rotator cuff activation",
      cardio: "HIIT Sprints: 6 x 30s at 90% effort",
      exercises: [
        { name: "Flat Barbell Bench Press", sets: 5, reps: "5,5,3,3,1", rest: 180, muscle: "Chest / Front Delt / Triceps", note: "PYRAMID: 85>87>90>92>95%. Max strength block", isKey: true },
        { name: "Incline DB Press", sets: 4, reps: "8-10", rest: 90, muscle: "Upper Chest", note: "Heavy — build upper chest shelf" },
        { name: "Weighted Dips", sets: 4, reps: "8-10", rest: 90, muscle: "Chest / Triceps", note: "BW + 25-45lb, lean forward for chest emphasis" },
        { name: "Standing Military Press", sets: 4, reps: "6-8", rest: 120, muscle: "All Delts", note: "Strict — build boulder shoulders", isKey: true },
        { name: "Cable Lateral Raise", sets: 4, reps: "12-15", rest: 60, muscle: "Medial Delt", note: "Constant tension, slow negatives — shoulder cap" },
        { name: "Close-Grip Bench Press", sets: 3, reps: "8-10", rest: 75, muscle: "Triceps", note: "Tricep mass builder" },
      ],
    },
    2: {
      name: "Pull Strength Pyramid",
      focus: "Pull Strength Pyramid",
      warmup: "10min dynamic + scapular activation",
      cardio: "Stairmaster: 20 min Zone 2",
      exercises: [
        { name: "Weighted Pull-Ups", sets: 5, reps: "5,5,3,3,1", rest: 180, muscle: "Lats / Biceps", note: "PYRAMID: BW+25>35>45>50>55lb. Full ROM", isKey: true },
        { name: "Barbell Row (Overhand)", sets: 4, reps: "6-8", rest: 120, muscle: "Mid Back / Rhomboids", note: "Heavy, strict — scapula squeeze" },
        { name: "Seated Cable Row (V-Grip)", sets: 3, reps: "10-12", rest: 75, muscle: "Mid Back", note: "Mid-back thickness" },
        { name: "Lat Pulldown (Wide)", sets: 3, reps: "10-12", rest: 75, muscle: "Lats", note: "Stretch + squeeze — V-taper width" },
        { name: "Barbell Curl (Straight)", sets: 4, reps: "8-10", rest: 75, muscle: "Biceps", note: "Heavy — no cheat, bicep mass" },
        { name: "Incline DB Curl", sets: 3, reps: "10-12", rest: 60, muscle: "Bicep Long Head", note: "Long head stretch at bottom" },
      ],
    },
    3: {
      name: "Legs Heavy + Power",
      focus: "Legs Heavy + Power",
      warmup: "10min mobility + glute activation",
      cardio: "Sled Push: 4 x 40m heavy",
      exercises: [
        { name: "Back Squat", sets: 5, reps: "5,5,3,3,1", rest: 180, muscle: "Quads / Glutes", note: "PYRAMID: 85>87>90>92>95%. Max squat strength", isKey: true },
        { name: "Bulgarian Split Squat", sets: 4, reps: "8/leg", rest: 90, muscle: "Quads / Hip Balance", note: "Heavy DB — extra set on weak side continues", isHip: true },
        { name: "Leg Press", sets: 4, reps: "10-12", rest: 90, muscle: "Quads / Glutes", note: "Heavy, full ROM, vary foot placement" },
        { name: "Romanian Deadlift", sets: 4, reps: "8-10", rest: 90, muscle: "Hamstrings / Glutes", note: "Heavy — hamstring builder" },
        { name: "Depth Jumps", sets: 4, reps: "5", rest: 90, muscle: "Explosive Power", note: "Reactive power for basketball verticals" },
        { name: "Standing Calf Raise", sets: 5, reps: "12-15", rest: 60, muscle: "Calves", note: "Heavy — full stretch, pause at top" },
      ],
    },
    4: {
      name: "Upper Hypertrophy + Core",
      focus: "Upper Hypertrophy + Core",
      warmup: "10min shoulder mobility",
      cardio: "Assault Bike: 8 x 20s on / 40s off MAX",
      exercises: [
        { name: "DB Floor Press", sets: 4, reps: "10-12", rest: 75, muscle: "Chest / Triceps", note: "Chest + tricep, no shoulder stress" },
        { name: "Cable Crossover", sets: 3, reps: "12-15", rest: 60, muscle: "Inner Chest", note: "Stretch + squeeze, pec definition" },
        { name: "Seated DB Shoulder Press", sets: 4, reps: "8-10", rest: 75, muscle: "All Delts", note: "Control + time under tension" },
        { name: "Chin-Ups", sets: 4, reps: "8-12", rest: 75, muscle: "Biceps / Lats", note: "Palms toward you — bicep emphasis" },
        { name: "Reverse Fly (Rear Delt)", sets: 3, reps: "15", rest: 45, muscle: "Rear Delt", note: "Rear delt for 3D shoulder look" },
        { name: "Hanging Leg Raise", sets: 4, reps: "12-15", rest: 60, muscle: "Lower Abs", note: "Lower ab definition" },
        { name: "Cable Woodchop", sets: 3, reps: "12/side", rest: 45, muscle: "Obliques / Core", note: "Rotational power for basketball" },
      ],
    },
    5: {
      name: "Legs Hypertrophy + Athletic",
      focus: "Legs Hypertrophy + Athletic",
      warmup: "10min mobility + hip circuit",
      cardio: "Sprint Intervals: 8 x 100m at 85-90%",
      exercises: [
        { name: "Front Squat", sets: 4, reps: "8-10", rest: 90, muscle: "Quads", note: "Upright torso, quad emphasis" },
        { name: "Hip Thrust (Barbell)", sets: 4, reps: "10-12", rest: 90, muscle: "Glutes", note: "Heavy, 2s pause at top — glute power", isKey: true },
        { name: "Walking Lunges (DB)", sets: 3, reps: "12/leg", rest: 75, muscle: "Quads / Glutes", note: "Heavy — functional strength + balance" },
        { name: "Leg Extension", sets: 4, reps: "12-15", rest: 60, muscle: "Quads", note: "Quad separation + definition" },
        { name: "Nordic Hamstring Curl", sets: 3, reps: "6-8", rest: 90, muscle: "Hamstrings", note: "Eccentric — #1 injury prevention exercise" },
        { name: "Single-Leg Box Jump", sets: 3, reps: "5/leg", rest: 75, muscle: "Explosive Power", note: "Unilateral explosive power" },
      ],
    },
    6: {
      name: "Basketball + Recovery",
      focus: "Basketball + Recovery",
      exercises: [
        { name: "Full Court Basketball", sets: 1, reps: "75 min", rest: 0, muscle: "Sport-Specific", note: "Skills, scrimmage, apply your training" },
        { name: "Foam Roll + Lacrosse Ball", sets: 1, reps: "15 min", rest: 0, muscle: "Recovery", note: "Hip flexors, IT band, lats" },
        { name: "Hip Mobility Circuit", sets: 1, reps: "10 min", rest: 0, muscle: "Hip Correction", note: "90/90 + pigeon + banded stretches" },
        { name: "Band Pull-Aparts", sets: 3, reps: "15", rest: 30, muscle: "Rear Delt / Posture", note: "Posture + shoulder health maintenance" },
      ],
    },
  },
  3: {
    1: {
      name: "Push Power + Definition",
      focus: "Push Power + Definition",
      warmup: "10min dynamic + CNS activation",
      cardio: "Bike Sprints: 8 x 20s MAX",
      exercises: [
        { name: "Bench Press (Pause Reps)", sets: 4, reps: "5", rest: 180, muscle: "Chest / Triceps", note: "2s pause on chest, EXPLODE up — dead-stop power", isKey: true },
        { name: "Push Press (Barbell)", sets: 4, reps: "5-6", rest: 120, muscle: "Shoulders / Full Body Power", note: "Explosive overhead — use leg drive", isKey: true },
        { name: "Incline Smith Press", sets: 4, reps: "8-10", rest: 75, muscle: "Upper Chest", note: "Constant tension, slow controlled reps" },
        { name: "Cable Lateral + Front Raise SS", sets: 3, reps: "12+12", rest: 60, muscle: "All Delts", note: "Superset — shoulder detail work" },
        { name: "Diamond Push-Ups", sets: 3, reps: "Max", rest: 60, muscle: "Triceps", note: "Tricep definition finisher — burnout" },
        { name: "Med Ball Chest Pass", sets: 4, reps: "8", rest: 60, muscle: "Chest / Power", note: "Explosive push power for basketball" },
        { name: "Ab Wheel Rollouts", sets: 3, reps: "10-12", rest: 60, muscle: "Core", note: "Anti-extension core strength" },
      ],
    },
    2: {
      name: "Pull Power + Definition",
      focus: "Pull Power + Definition",
      warmup: "10min dynamic + scapular work",
      cardio: "Stairmaster Intervals: 20 min (1 min hard / 1 min easy)",
      exercises: [
        { name: "Deficit Deadlift", sets: 4, reps: "3-5", rest: 180, muscle: "Full Posterior Chain", note: "Stand on 2\" platform — extended ROM, build off floor", isKey: true },
        { name: "Chest-Supported T-Bar Row", sets: 4, reps: "8-10", rest: 90, muscle: "Mid Back", note: "Strict, zero momentum — pure back thickness" },
        { name: "Wide-Grip Lat Pulldown", sets: 4, reps: "10-12", rest: 75, muscle: "Lats", note: "V-taper width builder" },
        { name: "Single-Arm Cable Row", sets: 3, reps: "12/side", rest: 60, muscle: "Lats / Core", note: "Anti-rotation + lat focus" },
        { name: "Preacher Curl (EZ Bar)", sets: 3, reps: "10-12", rest: 60, muscle: "Bicep Peak", note: "Peak bicep builder — no cheating" },
        { name: "Med Ball Slam", sets: 4, reps: "8", rest: 60, muscle: "Lats / Core / Power", note: "Explosive pull pattern — full body power" },
      ],
    },
    3: {
      name: "Legs Explosive + Definition",
      focus: "Legs Explosive + Definition",
      warmup: "10min mobility + neural activation",
      cardio: "Tire Flips or Sled Push: 5 rounds heavy",
      exercises: [
        { name: "Pause Squat", sets: 4, reps: "4-5", rest: 180, muscle: "Quads / Glutes", note: "3s pause in hole — EXPLODE up. Dead-stop power", isKey: true },
        { name: "Trap Bar Deadlift Jumps", sets: 4, reps: "5", rest: 90, muscle: "Full Body Power", note: "Moderate weight — MAX explosive power", isKey: true },
        { name: "Single-Leg Leg Press", sets: 3, reps: "10/leg", rest: 75, muscle: "Quads", note: "Correct any remaining imbalance", isHip: true },
        { name: "Walking Lunge (Barbell)", sets: 3, reps: "10/leg", rest: 75, muscle: "Quads / Glutes", note: "Functional + quad definition" },
        { name: "Calf Raise Complex", sets: 4, reps: "15+15", rest: 45, muscle: "Full Calves", note: "Seated + Standing back to back" },
        { name: "Lateral Bounds", sets: 4, reps: "6/side", rest: 60, muscle: "Lateral Power", note: "Lateral agility for basketball defense" },
      ],
    },
    4: {
      name: "Upper Detail + Core",
      focus: "Upper Detail + Core",
      warmup: "10min shoulder + thoracic mobility",
      cardio: "Rowing Machine: 12 min (30s sprint / 30s easy)",
      exercises: [
        { name: "Incline DB Fly", sets: 4, reps: "12", rest: 60, muscle: "Inner Chest", note: "Stretch + inner pec definition line" },
        { name: "Landmine Press", sets: 3, reps: "10/arm", rest: 75, muscle: "Shoulders / Core", note: "Shoulder-safe pressing + core engagement" },
        { name: "Rear Delt Fly (Incline)", sets: 4, reps: "12-15", rest: 45, muscle: "Rear Delts", note: "3D shoulder look from behind" },
        { name: "Supinated Barbell Row", sets: 4, reps: "8-10", rest: 90, muscle: "Lower Lats / Biceps", note: "Lower lat + bicep tie-in" },
        { name: "Concentration Curls", sets: 3, reps: "10/arm", rest: 45, muscle: "Bicep Peak", note: "Bicep peak definition" },
        { name: "Dragon Flags", sets: 3, reps: "6-8", rest: 60, muscle: "Full Core", note: "Advanced core definition — control the negative" },
        { name: "Russian Twist (Med Ball)", sets: 3, reps: "20", rest: 45, muscle: "Obliques", note: "Oblique definition for that V-line" },
      ],
    },
    5: {
      name: "Legs + Court Performance",
      focus: "Legs + Court Performance",
      warmup: "10min dynamic + glute activation",
      exercises: [
        { name: "Box Squat", sets: 4, reps: "5-6", rest: 120, muscle: "Quads / Glutes", note: "Explosive from dead stop — builds starting power", isKey: true },
        { name: "Hip Thrust (Banded)", sets: 4, reps: "12", rest: 75, muscle: "Glutes", note: "Heavy + band — glute power + lockout speed" },
        { name: "Lateral Step-Up", sets: 3, reps: "10/leg", rest: 60, muscle: "Quads / Glute Med", note: "Lateral strength for defensive slides" },
        { name: "Glute-Ham Raise", sets: 3, reps: "8-10", rest: 75, muscle: "Hamstrings / Glutes", note: "Posterior chain bulletproofing" },
        { name: "Single-Leg Continuous Hop", sets: 4, reps: "8/leg", rest: 60, muscle: "Plyometric Power", note: "Reactive agility for basketball" },
        { name: "Court Agility Drills", sets: 1, reps: "20 min", rest: 0, muscle: "Sport-Specific", note: "Cone drills, defensive slides, sprints" },
      ],
    },
    6: {
      name: "Full Court Game Day",
      focus: "Full Court Game Day",
      exercises: [
        { name: "Competitive Scrimmage", sets: 1, reps: "90 min", rest: 0, muscle: "Everything", note: "Full court — apply ALL training to the game" },
        { name: "Full Body Foam Roll", sets: 1, reps: "15 min", rest: 0, muscle: "Recovery", note: "Complete recovery protocol" },
        { name: "Hip Mobility Circuit", sets: 1, reps: "10 min", rest: 0, muscle: "Hip Health", note: "Maintain correction — 90/90, pigeon, banded" },
      ],
    },
  },
  4: {
    1: {
      name: "Push Heavy + Metabolic",
      focus: "Push Heavy + Metabolic",
      warmup: "10min dynamic + CNS priming",
      cardio: "Metabolic Circuit: Jump Rope > Burpees > Mt Climbers — 3 rounds x 45s each",
      exercises: [
        { name: "Bench Press", sets: 5, reps: "3-5", rest: 210, muscle: "Chest / Triceps", note: "88-93% — peak strength, long rest", isKey: true },
        { name: "Weighted Dips", sets: 4, reps: "6-8", rest: 90, muscle: "Chest / Triceps", note: "Heavy — chest + tricep mass under fatigue" },
        { name: "DB Press > Lateral Raise SS", sets: 4, reps: "8+15", rest: 75, muscle: "Delts", note: "Superset — shoulder cap finisher" },
        { name: "Incline DB Fly", sets: 3, reps: "12", rest: 60, muscle: "Inner Chest", note: "Stretch + squeeze, chest detail" },
        { name: "Skull Crushers", sets: 3, reps: "10-12", rest: 60, muscle: "Triceps", note: "Tricep horseshoe definition" },
        { name: "Med Ball Plyo Push-Up", sets: 3, reps: "8", rest: 60, muscle: "Power", note: "Explosive finish" },
      ],
    },
    2: {
      name: "Pull Heavy + Metabolic",
      focus: "Pull Heavy + Metabolic",
      warmup: "10min dynamic + scap activation",
      cardio: "Metabolic: Rower > KB Swing > Box Jump — 3 rounds x 45s each",
      exercises: [
        { name: "Deadlift", sets: 5, reps: "3-5", rest: 210, muscle: "Full Posterior Chain", note: "88-93% — peak pulling strength", isKey: true },
        { name: "Weighted Chin-Ups", sets: 4, reps: "6-8", rest: 90, muscle: "Lats / Biceps", note: "Heavy — bicep + back combo" },
        { name: "Meadows Row", sets: 3, reps: "10/arm", rest: 75, muscle: "Upper Back", note: "Upper back thickness" },
        { name: "Straight Arm Pulldown", sets: 3, reps: "12-15", rest: 60, muscle: "Lats", note: "Lat sweep definition" },
        { name: "Barbell Curl 21s", sets: 3, reps: "21", rest: 75, muscle: "Biceps", note: "7 bottom + 7 top + 7 full — insane pump" },
        { name: "Farmer's Walk", sets: 3, reps: "50m", rest: 60, muscle: "Traps / Grip / Core", note: "Heavy — grip + trap + core" },
      ],
    },
    3: {
      name: "Legs Power + Metabolic",
      focus: "Legs Power + Metabolic",
      warmup: "10min mobility + neural activation",
      cardio: "Sprint Intervals: 10 x 60m at 95%",
      exercises: [
        { name: "Back Squat", sets: 5, reps: "3-5", rest: 210, muscle: "Quads / Glutes", note: "88-93% — peak squat strength", isKey: true },
        { name: "Trap Bar Jump", sets: 4, reps: "5", rest: 90, muscle: "Full Body Power", note: "Maximum power output — explode" },
        { name: "Walking Lunge > Jump Lunge SS", sets: 3, reps: "10+10", rest: 75, muscle: "Quads / Power", note: "Hypertrophy + plyometric superset" },
        { name: "Glute-Ham Raise", sets: 3, reps: "10", rest: 75, muscle: "Hamstrings", note: "BW+ posterior chain finisher" },
        { name: "Calf Raise Complex", sets: 4, reps: "15+15", rest: 45, muscle: "Calves", note: "Seated + Standing — full development" },
      ],
    },
    4: {
      name: "Upper Pump + Detail",
      focus: "Upper Pump + Detail",
      warmup: "10min shoulder mobility",
      cardio: "Assault Bike Tabata: 8 x 20s on / 10s off — 4 min destroyer",
      exercises: [
        { name: "Cable Chest Press", sets: 4, reps: "12-15", rest: 60, muscle: "Chest", note: "Constant tension — pump focus" },
        { name: "Machine Press > Rear Fly SS", sets: 4, reps: "10+15", rest: 60, muscle: "All Delts", note: "360 degree shoulder development superset" },
        { name: "Lat Pulldown (Close)", sets: 4, reps: "10-12", rest: 60, muscle: "Lats", note: "Inner lat detail" },
        { name: "Cable Curl > Pushdown SS", sets: 3, reps: "12+12", rest: 60, muscle: "Biceps / Triceps", note: "Arm pump superset" },
        { name: "Face Pulls", sets: 3, reps: "15-20", rest: 45, muscle: "Rear Delt / RC", note: "Rear delt and posture — never skip" },
        { name: "Hanging Windshield Wipers", sets: 3, reps: "8-10", rest: 60, muscle: "Obliques / Core", note: "Advanced core definition" },
      ],
    },
    5: {
      name: "Legs Athletic + Conditioning",
      focus: "Legs Athletic + Conditioning",
      warmup: "10min dynamic + glute activation",
      cardio: "Full Court Sprint Suicides: 6 sets game-conditioning",
      exercises: [
        { name: "Front Squat", sets: 4, reps: "6-8", rest: 90, muscle: "Quads", note: "Quad definition under fatigue" },
        { name: "Hip Thrust > Band Walk SS", sets: 4, reps: "10+15", rest: 75, muscle: "Glutes", note: "Glute power + stability superset", isHip: true },
        { name: "Reverse > Lateral Lunge SS", sets: 3, reps: "8+8/leg", rest: 75, muscle: "Quads / Adductors", note: "Multi-plane movement" },
        { name: "Box Jump > Broad Jump", sets: 4, reps: "5+5", rest: 90, muscle: "Full Body Power", note: "Explosive power combo" },
        { name: "Agility Ladder + Cones", sets: 1, reps: "20 min", rest: 0, muscle: "Agility", note: "Basketball-specific movement patterns" },
      ],
    },
    6: {
      name: "Game Day + Recovery",
      focus: "Game Day + Recovery",
      exercises: [
        { name: "Competitive Scrimmage", sets: 1, reps: "90-120 min", rest: 0, muscle: "Everything", note: "Game intensity — you ARE the monster now" },
        { name: "Post-Game Recovery", sets: 1, reps: "20 min", rest: 0, muscle: "Recovery", note: "Stretch + foam roll + cold exposure 10-15min" },
      ],
    },
  },
};

// Nutrition data from original HTML — per calorie plan option
export const NUTRITION = {
  opt1: {
    label: "92.1 kg (203 lbs)",
    phases: [
      { phase: "Phase 1 — Cut", cal: 2500, p: 200, f: 74, c: 259, pPct: 32, fPct: 27, cPct: 41 },
      { phase: "Phase 2-3 — Build", cal: 3400, p: 220, f: 92, c: 423, pPct: 26, fPct: 24, cPct: 50 },
      { phase: "Phase 4 — Final Cut", cal: 2100, p: 240, f: 56, c: 160, pPct: 46, fPct: 24, cPct: 30 },
    ],
  },
  opt2: {
    label: "117.6 kg (259 lbs)",
    phases: [
      { phase: "Phase 1 — Cut", cal: 3200, p: 260, f: 94, c: 329, pPct: 33, fPct: 26, cPct: 41 },
      { phase: "Phase 2-3 — Build", cal: 4100, p: 280, f: 118, c: 480, pPct: 27, fPct: 26, cPct: 47 },
      { phase: "Phase 4 — Final Cut", cal: 2800, p: 300, f: 56, c: 270, pPct: 43, fPct: 18, cPct: 39 },
    ],
  },
};

export const FOODS_EAT = [
  "Chicken breast, tilapia, salmon (2x/wk), lean beef, eggs (4 whole + 2 whites/day), Greek yogurt, whey/casein protein",
  "Oats, sweet potato, brown rice, quinoa, whole grain bread — time carbs around training",
  "Avocado, olive oil, almonds, walnuts, natural PB, fatty fish — critical for testosterone",
  "Unlimited vegetables — broccoli, spinach, kale, peppers. Every single meal.",
];

export const FOODS_AVOID = [
  "SMOKING — destroys VO2 max, reduces protein synthesis 30%",
  "ALCOHOL — stops fat burning 24-48hrs, kills testosterone",
  "PANCAKES/WAFFLES — refined flour + sugar = empty calories",
  "CHEESE (limit 30g/day MAX) — calorie-dense, causes facial bloating",
  "FRIED FOOD / FAST FOOD — inflammation, visceral fat, zero nutrition",
  "SUGAR / SODA / ENERGY DRINKS — insulin spikes = fat storage",
  "SODIUM (under 2,300mg/day) — #1 cause of facial puffiness",
  "DAIRY MILK — replace with unsweetened almond/oat",
];

// Daily Meal Suggestions per phase (with actual food items & portions)
export const DAILY_MEALS = {
  cut: [
    { name: "Breakfast", time: "07:00", items: [
      { food: "Egg Whites", qty: "6", cal: 100, p: 24, c: 0, f: 0 },
      { food: "Whole Eggs", qty: "2", cal: 140, p: 12, c: 0, f: 10 },
      { food: "Oats", qty: "50g", cal: 190, p: 7, c: 34, f: 3 },
      { food: "Banana", qty: "1 medium", cal: 105, p: 1, c: 27, f: 0 },
    ]},
    { name: "Pre-Workout", time: "10:00", items: [
      { food: "Chicken Breast", qty: "150g", cal: 230, p: 43, c: 0, f: 5 },
      { food: "Brown Rice", qty: "100g cooked", cal: 130, p: 3, c: 28, f: 1 },
      { food: "Mixed Greens", qty: "1 cup", cal: 10, p: 1, c: 2, f: 0 },
    ]},
    { name: "Post-Workout", time: "13:00", items: [
      { food: "Whey Protein", qty: "40g", cal: 160, p: 32, c: 4, f: 2 },
      { food: "Dextrose", qty: "30g", cal: 120, p: 0, c: 30, f: 0 },
      { food: "Creatine", qty: "5g", cal: 0, p: 0, c: 0, f: 0 },
    ]},
    { name: "Lunch", time: "14:00", items: [
      { food: "Tilapia / Salmon", qty: "200g", cal: 220, p: 42, c: 0, f: 4 },
      { food: "Sweet Potato", qty: "200g", cal: 170, p: 3, c: 40, f: 0 },
      { food: "Broccoli", qty: "150g", cal: 50, p: 4, c: 10, f: 0 },
      { food: "Olive Oil", qty: "5ml", cal: 45, p: 0, c: 0, f: 5 },
    ]},
    { name: "Snack", time: "16:30", items: [
      { food: "Greek Yogurt (0%)", qty: "200g", cal: 120, p: 20, c: 8, f: 0 },
      { food: "Almonds", qty: "15g", cal: 90, p: 3, c: 3, f: 8 },
      { food: "Blueberries", qty: "80g", cal: 45, p: 1, c: 11, f: 0 },
    ]},
    { name: "Dinner", time: "19:30", items: [
      { food: "Lean Beef / Turkey", qty: "200g", cal: 260, p: 40, c: 0, f: 10 },
      { food: "Quinoa", qty: "80g cooked", cal: 95, p: 4, c: 17, f: 2 },
      { food: "Spinach Salad", qty: "large", cal: 30, p: 3, c: 4, f: 0 },
      { food: "Avocado", qty: "50g", cal: 80, p: 1, c: 4, f: 7 },
    ]},
  ],
  build: [
    { name: "Breakfast", time: "07:00", items: [
      { food: "Whole Eggs", qty: "4", cal: 280, p: 24, c: 0, f: 20 },
      { food: "Oats", qty: "80g", cal: 300, p: 11, c: 54, f: 5 },
      { food: "Banana", qty: "1 large", cal: 120, p: 1, c: 31, f: 0 },
      { food: "Peanut Butter", qty: "20g", cal: 120, p: 5, c: 3, f: 10 },
      { food: "Whole Milk", qty: "200ml", cal: 130, p: 7, c: 10, f: 8 },
    ]},
    { name: "Pre-Workout", time: "10:00", items: [
      { food: "Chicken Breast", qty: "200g", cal: 310, p: 58, c: 0, f: 7 },
      { food: "White Rice", qty: "200g cooked", cal: 260, p: 5, c: 58, f: 0 },
      { food: "Honey", qty: "15g", cal: 45, p: 0, c: 12, f: 0 },
    ]},
    { name: "Post-Workout", time: "13:00", items: [
      { food: "Whey Protein", qty: "50g", cal: 200, p: 40, c: 5, f: 3 },
      { food: "Dextrose", qty: "50g", cal: 200, p: 0, c: 50, f: 0 },
      { food: "Creatine", qty: "5g", cal: 0, p: 0, c: 0, f: 0 },
    ]},
    { name: "Lunch", time: "14:00", items: [
      { food: "Salmon / Lean Beef", qty: "250g", cal: 350, p: 50, c: 0, f: 16 },
      { food: "Sweet Potato", qty: "300g", cal: 255, p: 5, c: 60, f: 0 },
      { food: "Mixed Vegetables", qty: "200g", cal: 70, p: 5, c: 14, f: 0 },
      { food: "Olive Oil", qty: "10ml", cal: 90, p: 0, c: 0, f: 10 },
    ]},
    { name: "Snack", time: "16:30", items: [
      { food: "Greek Yogurt", qty: "200g", cal: 130, p: 20, c: 8, f: 0 },
      { food: "Granola", qty: "40g", cal: 180, p: 4, c: 28, f: 6 },
      { food: "Mixed Berries", qty: "100g", cal: 50, p: 1, c: 12, f: 0 },
      { food: "Walnuts", qty: "20g", cal: 130, p: 3, c: 3, f: 13 },
    ]},
    { name: "Dinner", time: "19:30", items: [
      { food: "Lean Beef", qty: "250g", cal: 330, p: 52, c: 0, f: 12 },
      { food: "Pasta / Brown Rice", qty: "150g cooked", cal: 195, p: 5, c: 40, f: 1 },
      { food: "Broccoli + Peppers", qty: "200g", cal: 60, p: 5, c: 12, f: 0 },
      { food: "Cheese", qty: "20g", cal: 80, p: 5, c: 0, f: 7 },
    ]},
    { name: "Before Bed", time: "22:00", items: [
      { food: "Casein Protein", qty: "30g", cal: 120, p: 24, c: 3, f: 1 },
      { food: "Almond Butter", qty: "15g", cal: 90, p: 3, c: 3, f: 8 },
    ]},
  ],
  final_cut: [
    { name: "Breakfast", time: "07:00", items: [
      { food: "Egg Whites", qty: "8", cal: 130, p: 28, c: 0, f: 0 },
      { food: "Whole Egg", qty: "1", cal: 70, p: 6, c: 0, f: 5 },
      { food: "Oats", qty: "40g", cal: 150, p: 6, c: 27, f: 3 },
    ]},
    { name: "Pre-Workout", time: "10:00", items: [
      { food: "Chicken Breast", qty: "180g", cal: 280, p: 52, c: 0, f: 6 },
      { food: "Rice Cakes", qty: "3", cal: 105, p: 2, c: 23, f: 0 },
    ]},
    { name: "Post-Workout", time: "13:00", items: [
      { food: "Whey Isolate", qty: "50g", cal: 190, p: 42, c: 3, f: 1 },
      { food: "Dextrose", qty: "25g", cal: 100, p: 0, c: 25, f: 0 },
      { food: "Creatine", qty: "5g", cal: 0, p: 0, c: 0, f: 0 },
    ]},
    { name: "Lunch", time: "14:00", items: [
      { food: "Tilapia / White Fish", qty: "250g", cal: 260, p: 52, c: 0, f: 4 },
      { food: "Sweet Potato", qty: "150g", cal: 130, p: 2, c: 30, f: 0 },
      { food: "Spinach + Kale", qty: "200g", cal: 50, p: 6, c: 8, f: 0 },
    ]},
    { name: "Snack", time: "16:30", items: [
      { food: "Greek Yogurt (0%)", qty: "200g", cal: 120, p: 20, c: 8, f: 0 },
      { food: "Celery + Cucumber", qty: "150g", cal: 20, p: 1, c: 4, f: 0 },
    ]},
    { name: "Dinner", time: "19:30", items: [
      { food: "Lean Turkey Breast", qty: "250g", cal: 290, p: 55, c: 0, f: 6 },
      { food: "Asparagus", qty: "200g", cal: 40, p: 4, c: 8, f: 0 },
      { food: "Olive Oil", qty: "5ml", cal: 45, p: 0, c: 0, f: 5 },
    ]},
  ],
};

// Get the meal plan key for a given phase
export function getMealPlanKey(phase) {
  if (phase === 1) return 'cut';
  if (phase === 2 || phase === 3) return 'build';
  return 'final_cut';
}

// Generate weekly meal prep shopping list
export function generateMealPrep(phase, days = 6) {
  const key = getMealPlanKey(phase);
  const dayMeals = DAILY_MEALS[key];
  const shoppingList = {};

  dayMeals.forEach(meal => {
    meal.items.forEach(item => {
      if (!shoppingList[item.food]) {
        shoppingList[item.food] = { qty: item.qty, count: days, cal: item.cal, p: item.p };
      } else {
        shoppingList[item.food].count += days;
      }
    });
  });

  return Object.entries(shoppingList).map(([food, data]) => ({
    food,
    weeklyQty: `${data.count}x ${data.qty}`,
    calPerServing: data.cal,
    proteinPerServing: data.p,
  }));
}

export const SUPPLEMENTS = [
  { id: "creatine", name: "Creatine", dosage: "5g/day" },
  { id: "whey", name: "Whey Protein", dosage: "post-workout" },
  { id: "vitd3", name: "Vitamin D3", dosage: "4000IU" },
  { id: "magnesium", name: "Magnesium", dosage: "400mg" },
  { id: "fish_oil", name: "Fish Oil", dosage: "3g" },
  { id: "zinc", name: "Zinc", dosage: "30mg" },
  { id: "caffeine", name: "Caffeine", dosage: "200mg pre" },
];

export const ACHIEVEMENTS = [
  { id: "first_workout", name: "First Blood", icon: "🩸", desc: "Log your first workout", condition: (data) => data.totalWorkouts >= 1 },
  { id: "iron_week", name: "Iron Week", icon: "⚡", desc: "Complete all 6 days in a week", condition: (data) => data.weekComplete },
  { id: "macro_master", name: "Macro Master", icon: "🍽️", desc: "Track all meals 7 days straight", condition: (data) => data.mealStreak >= 7 },
  { id: "century_club", name: "Century Club", icon: "🏋️", desc: "Bench 100kg+", condition: (data) => (data.maxBench || 0) >= 100 },
  { id: "squat_king", name: "Squat King", icon: "👑", desc: "Squat 150kg+", condition: (data) => (data.maxSquat || 0) >= 150 },
  { id: "deadlift_titan", name: "Deadlift Titan", icon: "⚡", desc: "Deadlift 200kg+", condition: (data) => (data.maxDeadlift || 0) >= 200 },
  { id: "streak_14", name: "Two Week Streak", icon: "🔥", desc: "14 consecutive workout days", condition: (data) => (data.streak || 0) >= 14 },
  { id: "streak_30", name: "Unstoppable", icon: "🌟", desc: "30 consecutive workout days", condition: (data) => (data.streak || 0) >= 30 },
  { id: "volume_1000", name: "Volume Crusher", icon: "📈", desc: "Accumulate 1000+ total reps", condition: (data) => (data.totalReps || 0) >= 1000 },
  { id: "pr_party", name: "PR Party", icon: "🎊", desc: "Set 5 personal records", condition: (data) => (data.totalPRs || 0) >= 5 },
  { id: "phase_complete", name: "Phase Master", icon: "🏆", desc: "Complete an entire phase", condition: (data) => data.phaseComplete },
  { id: "perfect_week", name: "Perfect Week", icon: "✨", desc: "All workouts + all meals tracked", condition: (data) => data.perfectWeek },
];

export const QUOTES = [
  "The only way to define your limits is by going beyond them.",
  "Discipline is choosing between what you want now and what you want most.",
  "Your body achieves what your mind believes.",
  "Consistency is the father of results.",
  "Beast mode: activated.",
  "Pain is temporary. Glory is forever.",
  "Small daily improvements compound into remarkable results.",
  "You are stronger than you think. Prove it.",
  "Effort is between you and you.",
  "The hardest lift is getting to the gym.",
  "Champions aren't made in gyms — they're made from something deep inside.",
  "Do something today your future self will thank you for.",
  "Make yourself uncomfortable. That's where growth happens.",
];

export function getPhase(week) {
  if (week <= 12) return 1;
  if (week <= 24) return 2;
  if (week <= 36) return 3;
  return 4;
}

export function getPhaseWeekRange(phase) {
  if (phase === 1) return [1, 12];
  if (phase === 2) return [13, 24];
  if (phase === 3) return [25, 36];
  return [37, 48];
}

// Progressive overload suggestion engine
export function getProgressiveOverload(exerciseName, history) {
  if (!history || history.length === 0) return null;

  // Sort by date descending
  const sorted = [...history].sort((a, b) => b.date.localeCompare(a.date));
  const latest = sorted[0];
  const previous = sorted.length > 1 ? sorted[1] : null;

  if (!latest.weight || !latest.reps) return null;

  // Simple progressive overload: if completed target reps, suggest weight increase
  const suggestions = [];

  if (latest.reps >= 10) {
    // If doing 10+ reps comfortably, suggest weight increase
    suggestions.push({
      type: 'weight_up',
      message: `Increase to ${latest.weight + 2.5}kg`,
      detail: `You hit ${latest.reps} reps at ${latest.weight}kg — time to go heavier`,
    });
  } else if (latest.reps < 6 && previous && previous.weight === latest.weight) {
    // If struggling with reps, suggest staying same weight
    suggestions.push({
      type: 'hold',
      message: `Stay at ${latest.weight}kg, aim for more reps`,
      detail: `Only ${latest.reps} reps — build up to 8+ before increasing`,
    });
  } else if (previous && latest.weight > previous.weight) {
    suggestions.push({
      type: 'new_weight',
      message: `Great progress! ${previous.weight}kg > ${latest.weight}kg`,
      detail: `Weight increased by ${(latest.weight - previous.weight).toFixed(1)}kg since last session`,
    });
  }

  return suggestions.length > 0 ? suggestions[0] : null;
}
